import { cn } from "@/lib/utils";
import { formatNOK } from "@/lib/format";

interface Props {
  lineSum: number;
  overheadAmount: number;
  effectiveOverheadPct: number;
  effectiveDiscount: number;
  total: number;
  totalMargin: number;
}

export function UpsellTotalsSummary({
  lineSum,
  overheadAmount,
  effectiveOverheadPct,
  effectiveDiscount,
  total,
  totalMargin,
}: Props) {
  return (
    <div className="space-y-2 px-2 pt-3 border-t text-sm">
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>Linjesum</span>
        <span>{formatNOK(lineSum)}</span>
      </div>
      {overheadAmount > 0 && (
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>Overhead ({effectiveOverheadPct}%)</span>
          <span>+{formatNOK(overheadAmount)}</span>
        </div>
      )}
      {effectiveDiscount > 0 && (
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>Rabatt</span>
          <span>−{formatNOK(effectiveDiscount)}</span>
        </div>
      )}
      <div className="flex items-center justify-between">
        <span className="text-muted-foreground">Total</span>
        <div className="flex items-center gap-4">
          <span>
            Sum: <strong className="text-foreground">{formatNOK(total)}</strong>
          </span>
          <span>
            Margin:{" "}
            <strong className={cn(totalMargin >= 0 ? "text-success" : "text-destructive")}>
              {formatNOK(totalMargin)}
            </strong>
          </span>
        </div>
      </div>
    </div>
  );
}
